import React from 'react';
import { getSignedMediaUrl } from '@/lib/utils';
import type { Sponsor } from '@/features/clubs/types/types';

interface SponsorsSectionProps {
  sponsors: Sponsor[];
}

const SponsorsSection: React.FC<SponsorsSectionProps> = ({ sponsors }) => {

  if (!sponsors || sponsors.length === 0) {
    return null;
  }

  const handleSponsorClick = (sponsor: Sponsor) => {
    if (sponsor.website) {
      window.open(sponsor.website, '_blank', 'noopener,noreferrer');
    } else {
      console.log('No website URL provided for sponsor');
    }
  };

  return (
    <section className="text-center flex flex-col justify-center min-h-[200px]">
      <h3 className="text-lg font-semibold text-gray-400 uppercase tracking-wider mb-6">
        Proudly Sponsored By
      </h3>
      <div className="flex justify-center items-center gap-12">
        {sponsors.map((sponsor, index) => (
          <button 
            key={index} 
            onClick={() => handleSponsorClick(sponsor)}
            className="hover:opacity-80 transition-opacity cursor-pointer"
          >
            {sponsor.logo && sponsor.logo !== '00000000-0000-0000-0000-000000000000' ? (
              <img 
                src={getSignedMediaUrl(sponsor.logo, 'image').url} 
                alt="Sponsor Logo" 
                className="h-24 filter grayscale brightness-200 hover:filter-none transition-all" 
              />
            ) : (
              <div className="h-24 w-40 bg-gray-600 rounded flex items-center justify-center">
                <span className="text-gray-400 text-lg">Sponsor</span>
              </div>
            )}
          </button>
        ))}
      </div>
    </section>
  );
};

export default SponsorsSection;
